// extracted by mini-css-extract-plugin
export var actionButton = "_62-0";
export var attachmentLine = "_62-1";
export var fileInput = "_62-2";
export var fileUploadWrapper = "_62-4";
export var footer = "_62-3";
export var modalContent = "_62-5";
export var paperclip = "_62-6";
export var quillEditor = "_62-7";